"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.travelDates = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const colors_1 = require("../basic/colors");
exports.travelDates = (0, basic_1.applyBase)({
    durationDropdownWrapper: {
        '.input': Object.assign(Object.assign({ py: 2 }, font_faces_1.FONT_SIZE.MEDIUM), { '&:focus-visible': {
                outline: 'auto 2px',
                outlineOffset: '-1px',
                outlineColor: colors_1.baseColors.black,
            } }),
        '.chevron': {
            bottom: '18px',
        },
    },
    travelDatesContainerCss: {
        width: '100%',
        flexShrink: 0,
        zIndex: 0,
        mt: ['48px !important', '0 !important'],
        pt: ['10px', '20px'],
        px: 3,
        '.DayPicker': {
            width: '100%',
        },
        '.DayPicker-wrapper': {
            outline: 'none',
        },
        '.DayPicker-NavBar': {
            button: {
                '&:focus-visible': {
                    svg: {
                        outline: 'auto 2px',
                        outlineColor: colors_1.baseColors.black,
                    },
                },
            },
        },
        '.DayPicker-Months': {
            flexDirection: 'column',
        },
        '.DayPicker-Month': {
            width: '100%',
            margin: 0,
        },
        '.DayPicker-Month .DayPicker-Caption div': Object.assign({}, font_faces_1.FONT_SIZE.XS),
        '.DayPicker-Month .DayPicker-Caption': {
            textAlign: 'right',
            margin: 0,
            padding: 0,
        },
        '.DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled), .DayPicker-Day--inside-range:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled)': {
            color: 'black',
        },
        '.DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside), .DayPicker-Day--inside-range:not(.DayPicker-Day--outside)': {
            backgroundColor: 'lightGreyFirst',
            color: 'black',
        },
        '.DayPicker-Day': {
            borderRadius: 0,
            height: '50px',
            width: '50px',
            lineHeight: 1.1,
            outlineOffset: '-1px',
        },
        '.DayPicker-Day--today': {
            fontWeight: 'normal',
        },
        '.DayPicker-Day--today--disabled': {
            color: 'lightGreyFirst',
        },
        '.DayPicker-Day--disabled': {
            color: 'lightGreyFirst',
        },
        '.DayPicker-Day--today:not(.DayPicker-Day--selected):not(.DayPicker-Day--outside)': {
            position: 'relative',
            color: 'white',
            zIndex: 1,
        },
        '.DayPicker-Day--today:not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):after': {
            content: '""',
            width: '30px',
            height: '30px',
            backgroundColor: 'primary',
            borderRadius: '50%',
            display: 'block',
            position: 'absolute',
            zIndex: -1,
            // HACK: IE hack, transform is not working properly
            top: '10px',
            left: '10px',
        },
        '.date-picker .DayPicker-Body .DayPicker-Week .DayPicker-Day--start:not(.DayPicker-Day--outside)': {
            borderTopLeftRadius: '4px',
            borderBottomLeftRadius: '4px',
            backgroundColor: 'black',
        },
        '.date-picker .DayPicker-Body .DayPicker-Week .DayPicker-Day--end:not(.DayPicker-Day--outside)': {
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px',
            backgroundColor: 'black',
        },
        '.DayPicker-Caption': {
            height: `24px`,
            lineHeight: `24px`,
        },
        '.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover': {
            backgroundColor: 'lightGreyFirst',
        },
    },
    bottomPanelCss: {
        boxShadow: 'none',
        position: 'sticky',
        display: ['initial', 'flex'],
        justifyContent: 'space-between',
        alignItems: 'center',
        py: [0, 2],
        px: 3,
        zIndex: '1',
        bottom: 0,
        borderTop: ['1px solid', 'none'],
        borderColor: 'lightGreyFirst',
        backgroundColor: 'background',
        '&:after': {
            content: ['', "''"],
            top: 0,
            position: 'absolute',
            borderTop: '1px solid',
            borderColor: 'lightGreyFirst',
            width: 'calc(100% - 32px )',
        },
        left: 0,
        width: '100%',
        '.travel-dates-information': {
            color: 'black',
            position: 'static',
            px: [0, '9px'],
            backgroundColor: 'white',
            fontSize: '16px',
            textAlign: ['initial', 'center'],
        },
        '.applyButton': {
            width: 'auto',
            borderRadius: 4,
            '&:focus-visible': {
                outline: 'auto 2px',
                outlineOffset: '-1px',
                outlineColor: colors_1.baseColors.black,
            },
        },
    },
    headerCss: {
        pt: [0, '20px'],
        pb: [null, '20px'],
        position: ['initial', 'relative'],
        bottom: [0, 0],
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        order: [1, 0],
        backgroundColor: 'background',
        left: 0,
        width: '100%',
        zIndex: 2,
        borderBottom: [null, '1px solid'],
        borderColor: [null, '#ECECED'],
        '.header-group-duration-dropdown': {
            flexGrow: 1,
            pl: 3,
        },
        '.travel-dates-duration-dropdown': {
            maxWidth: ['none', '350px'],
        },
    },
    headerGroupCss: {
        display: 'flex',
        flexDirection: 'column',
        pl: [0, 3],
        pb: [3, 0],
        '.label-flexible, .label-exact': {
            fontSize: [1, 2],
            mr: 2,
            mb: 2,
        },
        '.label-flexible': {
            flex: 1,
        },
    },
    navbarControlCss: {
        position: 'absolute',
        width: '100%',
        color: 'inherit',
        'button:disabled': {
            color: 'lightGreyFirst',
            cursor: 'default',
        },
    },
    weekDaysListCss: {
        borderTop: [null, '1px solid'],
        borderBottom: [null, '1px solid'],
        borderColor: ['lightGreyFourth', 'lightGreyFourth'],
        fontSize: 2,
        position: ['absolute', 'relative'],
        backgroundColor: 'white',
        width: '100%',
        top: ['55px', 'auto'],
        zIndex: 2,
        textAlign: 'center',
        color: 'secondary',
        py: '12px !important',
        '&:after': {
            content: "''",
            backgroundColor: 'lightGreyFourth',
            position: 'absolute',
            left: 3,
            bottom: 0,
            height: ['1px', 0],
            width: 'calc(100% - 32px)',
        },
    },
    travelDatesDesktop: {
        display: 'flex',
        flexDirection: 'column',
        '.date-picker': {
            '.DayPicker-Months': {
                flexDirection: 'row',
                justifyContent: 'space-between',
            },
            '.DayPicker-Month': {
                width: '48%',
            },
            '.DayPicker-Month .DayPicker-Caption': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.XS), { textAlign: 'center', mb: [null, 3] }),
            '.DayPicker-Weekday': {
                color: 'secondary',
                py: [null, '13px'],
                fontSize: [null, 1],
            },
        },
    },
    travelDatesMobile: {
        display: 'flex',
        flexDirection: 'column',
        '.applyButton': {
            mb: 3,
            mt: 0,
            width: '100%',
            borderRadius: 4,
        },
    },
});
//# sourceMappingURL=travel-dates.js.map